import Cookies from 'js-cookie'

var TokenKey = 'CSRF-TOKEN';

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  if (window.location.protocol === 'https:') {
    return Cookies.set(TokenKey, token, {secure:true,sameSite:'None',})
  } else {
    return Cookies.set(TokenKey, token)
  }
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setIsLogin(val) {
  if (window.location.protocol === 'https:') {
    return Cookies.set('isTdLogin', val, {secure:true,sameSite:'None',})
  } else {
    return Cookies.set('isTdLogin', val)
  }
    
}
export function getIsLogin() {
    return Cookies.get('isTdLogin')
}
export function removeIsLogin() {
    Cookies.remove('PHPSESSID',{ path: '/td' });
    Cookies.remove('CSRF-TOKEN',{ path: '/td' });
    return Cookies.remove('isTdLogin')
}

